export const kycUrls = (k) => (Array.isArray(k?.id_doc_urls) && k.id_doc_urls.length ? k.id_doc_urls : k?.id_doc_url ? [k.id_doc_url] : []);
